import { render, staticRenderFns } from "./DeletesItems.vue?vue&type=template&id=617aa346&"
import script from "./DeletesItems.vue?vue&type=script&lang=js&"
export * from "./DeletesItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports